import { render, staticRenderFns } from "./UHs.vue?vue&type=template&id=072f0c0d&"
import script from "./UHs.vue?vue&type=script&lang=js&"
export * from "./UHs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports